import React from 'react'
import VariantPickerWidget from './VariantPickerWidget'
import _ from 'lodash'
import { ProductVariantPropertyJson } from '../types'

const ProductVariantsPicker: React.FC<{
  attributes: {
    name: string
    values: string[]
  }[]
  selectedAttributes: { [key: string]: string }
  onChange(data: { [key: string]: string }): void
  attrsByVariant: { [key: number]: ProductVariantPropertyJson[] }
}> = ({ attributes, onChange, selectedAttributes, attrsByVariant }) => {
  return (
    <div className='mb-10'>
      {attributes.map(({ name, values }, i) => {
        const selectedAttrNames = Object.keys(selectedAttributes).filter(key => key !== name)
        const selectedAttrValues = Object.values(selectedAttributes)
        const filteredAttrs = Object.values(attrsByVariant)
          .filter(attrs =>
            attrs.find(
              attr => selectedAttrNames.includes(attr.attributeName) && selectedAttrValues.includes(attr.valueName)
            )
          )
          .flat()
          .filter(prop => prop.attributeName === name)
        const filteredValues = _.uniq(_.sortBy(filteredAttrs, ['sortOrder', 'id']).map(prop => prop.valueName))
        const currentProps = Object.values(attrsByVariant).filter(
          attrs =>
            !!attrs.find(
              attr => selectedAttrNames.includes(attr.attributeName) && selectedAttrValues.includes(attr.valueName)
            )
        )

        return (
          <VariantPickerWidget
            key={name}
            selected={selectedAttributes[name]}
            onChange={(key, val) => {
              onChange({ ...selectedAttributes, [key]: val })
            }}
            label={name}
            options={filteredValues.length ? filteredValues : values}
            currentProps={currentProps}
            allProps={Object.values(attrsByVariant)}
          />
        )
      })}
    </div>
  )
}

export default React.memo(ProductVariantsPicker)
